export default __webpack_public_path__ + "static/media/home-bg.f15dc830.jpg";